import React from "react";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import { SectionHeading } from "@/components/home/SectionHeading";

const BENEFITS = [
  "Helps reduce scratching",
  "Creates a protective barrier",
  "Locks in moisture",
  "Supports the skin barrier",
  "Gentle for sensitive skin",
];

export const PatchSection = () => {
  const navigate = useNavigate();
  return (
    <section id="patch-system" className="bg-[#E9E2D6]/40 py-16 md:py-24" data-testid="patch-system">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading overline="Baby Hemp Skin Barrier Protection System" title="Targeted Protection For Eczema-Prone Skin" />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Static product imagery */}
          <div className="order-2 lg:order-1 grid grid-cols-2 gap-4">
            <div className="rounded-3xl overflow-hidden aspect-[3/4] bg-gradient-to-b from-[#F8F5EF] to-[#E9E2D6]/50 shadow-[0_8px_40px_rgba(111,80,58,0.06)] flex items-center justify-center p-4">
              <img src="/assets/bundle.png" alt="Baby Hemp patch pouch and balm system" loading="lazy" className="w-full h-full object-contain drop-shadow-[0_16px_24px_rgba(111,80,58,0.1)]" />
            </div>
            <div className="rounded-3xl overflow-hidden aspect-[3/4] bg-gradient-to-b from-[#F8F5EF] to-[#E9E2D6]/50 shadow-[0_8px_40px_rgba(111,80,58,0.06)] flex items-center justify-center p-6">
              <img src="/assets/patch.png" alt="Baby Hemp hydrocolloid patch" loading="lazy" className="w-full h-full object-contain drop-shadow-[0_16px_24px_rgba(111,80,58,0.12)]" />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <p className="text-[#6F503A]/75 text-lg leading-relaxed">
              Our hydrocolloid patches help create a protective barrier over irritated areas, helping reduce scratching and rubbing while supporting the skin barrier.
            </p>
            <ul className="mt-7 space-y-3">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-start gap-3 text-[#6F503A]/85">
                  <span className="mt-0.5 w-5 h-5 rounded-full bg-[#B8C4A3]/30 flex items-center justify-center flex-shrink-0">
                    <Check className="w-3 h-3 text-[#6F503A]" />
                  </span>
                  {b}
                </li>
              ))}
            </ul>
            <button
              data-testid="patch-system-cta"
              onClick={() => navigate("/product/patch")}
              className="mt-9 px-7 py-4 rounded-full bg-[#6F503A] text-[#F8F5EF] font-medium hover:bg-[#5b4130] transition-colors"
            >
              Shop Patches
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
